import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { TextP } from '../../Defaults/Text';
import {
  FlexCol,
  FlexColCenterVertical,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { TableRow, TableTd } from '../../Zemplin/General/Table';
import { DsiSvgIcon as SvgIcon, IconType } from '../General/SvgIcon';
import { CountSetter } from '../Product/CountSetter';
import { ProductPriceCartTable } from '../Product/ProductPriceCartTable';
import { ButtonWithRequest } from '../Product/ButtonWithRequest';
import { useState } from 'react';
import { __ } from 'react-i18n/lib';
import { getImagePath, resolveProductName } from '../../../utilities/product';
import { formatPrice, prop } from '../../../utilities';
import { PriceTooltip } from './PriceTooltip';
import { Link } from 'react-router';
import { resolveCategoryName } from '../../../utilities/category';

export interface Props {
  data?: any;
  theme: any;
  color?: string;
  handleAddToCart: any;
  showWithVat?: boolean;
  managerLink?: string;
}

function PurchaseRow({
  data,
  theme,
  color = '',
  handleAddToCart,
  showWithVat,
  managerLink,
}: Props) {
  if (!data) {
    return null;
  }
  // const { id, date, status, sumPrice, ordernr } = getOrderRowInfo(order);
  // const color = getOrderColor(status, theme);
  const [count, setCount] = useState(1);
  const [showAvgPrice, setShowAvgPrice] = useState(false);
  const handleCountChange = newValue => {
    setCount(newValue);
  };

  const { product_detail } = data;

  const formattedAvgPrice = prop(product_detail, 'excluded')
    ? formatPrice(
        showWithVat
          ? data.month_price_avg *
              (1 + prop(data, 'product_detail.vat_rate') / 100)
          : data.month_price_avg,
        prop(product_detail, 'currency'),
      )
    : formatPrice(
        showWithVat
          ? data.month_price_avg *
              (1 + prop(data, 'product_detail.main_good.vat_rate') / 100)
          : data.month_price_avg,
        prop(product_detail, 'main_good.currency.id'),
      );

  const formattedPrice = formatPrice(
    showWithVat
      ? prop(data, 'product_detail.main_good.final_price')
      : prop(data, 'product_detail.main_good.final_price_without_vat'),
    prop(product_detail, 'main_good.currency.id'),
  );

  const handleIconHover = () => {
    setShowAvgPrice(true);
  };

  const handleIconHoverLeave = () => {
    setShowAvgPrice(false);
  };

  return (
    <StyledTableRow>
      <StyledTableTd>
        <FlexRowCenterVertical>
          <FlexCol>
            <Link
              to={
                prop(product_detail, 'excluded')
                  ? null
                  : `/${prop(product_detail, 'publish.0.product_url') ||
                      prop(product_detail, 'url')}`
              }
            >
              <Image
                width={56}
                height={56}
                alt={`${__('Obrázok produktu')} ${resolveProductName(
                  product_detail,
                )}`}
                src={
                  prop(product_detail, 'picture')
                    ? getImagePath(prop(product_detail, 'picture'), {
                        width: 56,
                        height: 56,
                      })
                    : '/images/icons/placeholder.svg'
                }
              />
            </Link>
          </FlexCol>
          <NamePluFlexCol>
            <Link
              to={
                prop(product_detail, 'excluded')
                  ? null
                  : `/${prop(product_detail, 'publish.0.product_url') ||
                      prop(product_detail, 'url')}`
              }
            >
              <ProductName color={color}>
                {resolveProductName(product_detail)}
              </ProductName>
            </Link>
            <Link
              to={
                prop(product_detail, 'excluded')
                  ? null
                  : `/${prop(product_detail, 'publish.0.product_url') ||
                      prop(product_detail, 'url')}`
              }
            >
              <ProductPlu>{prop(product_detail, 'plu')}</ProductPlu>
            </Link>
            {managerLink && (
              <a
                href={`${managerLink}&query=${prop(product_detail, 'plu')}`}
                target="_blank"
              >
                Report
              </a>
            )}
          </NamePluFlexCol>
        </FlexRowCenterVertical>
      </StyledTableTd>
      <StyledTableTd>
        <StatusText color={color} align={true}>{`${
          data.avg_quantity_delivered
        } ${__('ks')}`}</StatusText>
      </StyledTableTd>
      <StyledTableTd>
        <StatusText color={color} align={true}>{`${
          data.quantity_delivered
        } ${__('ks')}`}</StatusText>
      </StyledTableTd>
      <StyledTableTd>
        <FlexColCenterVertical>
          <PriceRow marginBottom={4}>
            {prop(product_detail, 'excluded') ? (
              <>
                <Price>{formattedAvgPrice}</Price>
                <PriceTooltip text={<>{`${__('Priemerná cena')} `}</>} />
              </>
            ) : (
              <>
                <Price>
                  {showAvgPrice ? formattedAvgPrice : formattedPrice}
                </Price>
                <div
                  onMouseOver={handleIconHover}
                  onMouseLeave={handleIconHoverLeave}
                >
                  <PriceTooltip
                    text={
                      <>
                        {`${__('Priemerná cena')} `} {formattedAvgPrice}
                      </>
                    }
                  />
                </div>
              </>
            )}
          </PriceRow>
          {data.backorder > 0 && (
            <PriceRow>
              <SvgIcon
                icon={IconType.cart}
                fill={'#36BF91'}
                width={16}
                height={16}
                marginRight={8}
              />
              <StatusText color={color} align={true} fontSize={14}>
                {`${__('Objednaných máte')} ${data.backorder} ${__('ks')}`}
              </StatusText>
            </PriceRow>
          )}
        </FlexColCenterVertical>
      </StyledTableTd>
      <StyledTableTd>
        {prop(product_detail, 'excluded') ? null : (
          <CountSetter
            minValue={1}
            count={count}
            onChange={handleCountChange}
          />
        )}
      </StyledTableTd>
      <StyledTableTd>
        {prop(product_detail, 'excluded') ? null : (
          <ButtonWithRequest
            onButtonClick={handleAddToCart}
            onRequestClick={''}
            avail_id={prop(
              product_detail,
              'main_good.availability.avail_id',
              0,
            )}
            hasDropdown={false}
            count={count}
            canOrder={true}
            product={product_detail}
            addToCompare={() => {}}
          />
        )}
      </StyledTableTd>
    </StyledTableRow>
  );
}

const StyledTableTd = styled(TableTd)<{ align: boolean }>`
  padding: ${rem(16)} ${rem(24)};
  border-bottom: ${({ theme }) => theme.borders.primary};
`;

const StyledTableRow = styled(TableRow)`
  padding: ${rem(24)} 0;
  border-top: ${({ theme }) => theme.borders.primary};
  background-color: ${({ theme }) => theme.colors.white};

  &:last-child {
    border-bottom: ${({ theme }) => theme.borders.primary};
  }
`;

const StatusText = styled(TextP)<{
  color?: string;
  align?: boolean;
  fontSize?: number;
}>`
  font-size: ${({ fontSize }) => (fontSize ? rem(fontSize) : rem(16))};
  line-height: ${rem(22)};
  color: ${({ theme, color }) =>
    color === 'red' ? theme.colors.dangerColor : theme.colors.textPrimary};
  font-weight: ${({ color }) => (color === 'red' ? '500' : '400')};
  text-align: ${({ align }) => (align ? 'right' : 'left')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const NamePluFlexCol = styled(FlexCol)`
  margin-left: ${rem(16)};
`;

const ProductName = styled(TextP)`
  font-weight: 500;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 200px;
  height: 1.2em;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`;

const ProductPlu = styled(TextP)`
  font-size: ${rem(14)};
  color: #aaaaaa;

  &:hover {
    text-decoration: underline;
  }
`;

const Image = styled.img`
  margin-right: ${rem(16)};
  min-width: ${rem(40)};
`;

const PriceRow = styled(FlexRowCenterVertical)<{ marginBottom?: number }>`
  width: 100%;
  text-align: right;
  margin-bottom: ${({ marginBottom }) =>
    marginBottom ? rem(marginBottom) : 0};
  justify-content: flex-end;
`;

const Price = styled(TextP)`
  font-size: ${rem(20)};
  font-weight: 500;
  margin-right: ${rem(10)};
  text-align: right;
  white-space: nowrap;
`;

const WithThemeRow: any = withTheme(PurchaseRow);
export { WithThemeRow as DsiPurchaseRow };
